import { Component, OnInit, OnDestroy } from '@angular/core';
import { BlogService } from '../../../services/blog.service';
import { BannerService } from '../../../services/banner.service';
import { ActivatedRoute } from '@angular/router';
import { NewsService } from 'src/app/services/news.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-blogview',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})

export class BlogviewComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public loading: boolean;
  public blogContent;
  public blogTitle;
  public errorMessage: string;
  public bannerList: any[];
  public bannerImageList: any[] = [];
  public disabled: boolean = false;
  public blogImage: any[];
  tplNews: any[] = [];
  public id;
  public Newscenter_config: SwiperConfigInterface = {
    direction: 'vertical',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    pagination:false,
    breakpoints: {
      320: {
        slidesPerView: 5,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 5,
        spaceBetween: 0
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 0
      }
    }
  };

  constructor(private blogService: BlogService, private newsService: NewsService, private bannerService: BannerService, private activeroute: ActivatedRoute) { }

  ngOnInit(): void {
    this.id = this.activeroute.snapshot.params.id;
    this.getBanner();
    this.getBlogdetails();
  }

  getBlogdetails() {
    var query = "?filterByDisable=false&sortBy=created_at&orderBy=DESC";
    this.blogService.getBlogwithoutAuth(this.id).pipe(takeUntil(this.destroy$)).subscribe(data => {   
      this.loading = false;
      this.blogTitle = data['title'];
      this.blogContent = data['description'];
      this.blogImage=data.blogImage[0].image_src;
    },
    err => {
      this.errorMessage = err.error.message;
    });
    var query = "?filterByDisable=false&filterByStatus=true";
    this.newsService.getNewsDetails(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data.data.totalCount > 0) {
        this.tplNews = data.data.items;
      }
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=blog";
    this.bannerService.getbannerList(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.loading = false;
      this.bannerList = data.data.items;
      this.bannerList.forEach(element => {
        this.bannerImageList = element.banner_image;
      });
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  public onIndexChange(index: number): void {
  }

  public onSwiperEvent(event: string): void {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}